import React, { ComponentType, useState } from "react";
import ErrorText from "../ErrorText/ErrorText";
import styles from "./InputWithLabelAndError.module.scss";
import { combineClasses } from "@/lib/utils";
import { useFormState } from "react-hook-form";
import {
  FormControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";
import InstructionsIcon from "../SVGComponents/InstructionsIcon";

const withLabelAndError = (
  InputComponent: WithLabelAndErrorComponent,
  PopupComponent?: ComponentType<{ onClose: () => void }>
) => {
  const InputWithLabelAndError: WithLabelAndErrorComponent = ({
    controlType,
    errorMessage,
    isRequired,
    largeLabel = false,
    smallLabel = false,
    ...props
  }) => {
    const [showPopup, setShowPopup] = useState(false);
    const { control, label, name, hideOuterLabel } = props as any;
    const togglePopup = () => setShowPopup((prev) => !prev);
    // eslint-disable-next-line
    const { errors } = control ? useFormState({ control, name }) : {};

    const errorText = errors?.[name]?.message || errorMessage || "";

    const labelHtml = (label || PopupComponent) && !hideOuterLabel ? (
      <label 
        className={combineClasses(
          styles.label,
          largeLabel && styles.largeLabel,
          smallLabel && styles.smallLabel
        )} 
        htmlFor={name}
      >
        {label}
        {label && <>&nbsp;</>}
        
        {label && isRequired ? <span className={styles.requiredMark}>*</span> : ""}
        {PopupComponent && (
          <span
            className={styles.popupText}
            onMouseEnter={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setShowPopup(true);
            }}
            onMouseLeave={() => setShowPopup(false)}
          >
            <InstructionsIcon style={{ height: "1rem", padding: "0rem" }} />
          </span>
        )}
        {PopupComponent && showPopup && (
          <PopupComponent onClose={togglePopup} />
        )}
      </label>
    ) : null;

    const errorHtml = <ErrorText>{errorText as string}</ErrorText>;

    return controlType === "checkbox" ? (
      <div className={combineClasses(styles.checkboxControl)}>
        <div className={styles.checkboxContainer}>
          <InputComponent {...(props as FormControlProps)} />
          {labelHtml}
        </div>
        {errorHtml}
      </div>
    ) : (
      <div
        className={combineClasses(
          styles.inputControl,
          controlType === "textarea" && styles.textareaControl
        )}
      >
        {labelHtml}
        <InputComponent
          {...(props as FormControlProps)}
          error={Boolean(errorText)}
        />
        {errorHtml}
      </div>
    );
  };

  return InputWithLabelAndError;
};

export default withLabelAndError;
